import { datadogRum } from "@datadog/browser-rum";
import { useRouter } from "next/router";
import { pick } from "ramda";
import { useEffect, useRef } from "react";

import Logger from "~/services/logger/logger";
import appRoutes from "~/utils/app-routes";

const datadogViews = Object.fromEntries(
  Object.entries({
    ...pick(
      [
        "HOMEPAGE",
        "CART",
        "THANKYOU",
        "SIGN_UP",
        "LOGIN",
        "CHECKOUT",
        "CUSTOMER_HELP_CENTER",
        "FAQ_HELP",
        "PASSWORD_RESET_REQUEST",
      ],
      appRoutes
    ),
    PDP: "/p/[slug]",
    PLP: "/c/[...category]",
    // Sanitize paths by having them all start by "/"
  }).map(([key, path]) => [`/${path}`.replace("//", "/"), key])
);

export const useDatadogRumStartView = () => {
  const router = useRouter();
  const lastViewRef = useRef<string | null>(null);

  useEffect(() => {
    const viewName = datadogViews[router.pathname];
    Logger.instance.debug(`Datadog RUM view for ${router.pathname}: ${viewName}`);

    if (viewName && lastViewRef.current !== viewName) {
      datadogRum.startView(viewName);
      lastViewRef.current = viewName;
    }
  }, [router.pathname]);
};
